import gearboxes, { gearboxNames } from '@constants/values/gearboxes'
import opcjePaliwa from '@components/search/inputs/opcjePaliwaConstruction'
import rodzajNapedu from '@components/search/inputs/rodzajNapeduConstruction'
import pojemnoscSkokowa from '@components/search/inputs/pojemnoscSkokowa'
import mocSilnika from '@components/search/inputs/mocSilnika'
import liczbaOsi from '@components/search/inputs/liczbaOsi'

const silnikNaped = { t: 'Silnik i napęd', inputs: [
    opcjePaliwa,
    { t: 'Skrzynia biegów', type: 'all-checkbox', name: 'skrzynia-biegow', options: gearboxes, names: gearboxNames },
    rodzajNapedu,
    { type: 'blank' },
    { t: 'Liczba silników', type: 'range', name: 'liczba-silnikow' },
    { t: 'Liczba łopat silnika', type: 'range', name: 'liczba-lopat-silika', small: true },
    pojemnoscSkokowa,
    mocSilnika,
    { t: 'Moc użyteczna', type: 'range', name: 'moc-uzyteczna', unit: 'KM', small: true },
    { t: 'Moc agregatu', type: 'range', name: 'moc-agregatu', unit: 'kVA', small: true },
    liczbaOsi,
]}

export default silnikNaped